

function Loader() {
    return (
        <div>
       <div className="loader">
           <img src="https://i.ibb.co/Pw4zhyK/spinner.gif" alt="Loading"/>
           <h1>Fetching data</h1>
       </div>     
        </div>
    )
}

export default Loader
